<template>
  <div>
    <!-- <h3>New Urls Form</h3> -->
    <v-card>
      <v-card-title></v-card-title>
      <v-card-subtitle>
        <ol>
          <!-- <li><v-icon color="warning">warning</v-icon></li> -->

          <li>
            <v-icon v-if="!!title_validation" color="success">verified</v-icon>
            <v-icon v-else color="warning">warning</v-icon>
            <span v-if="!title_validation">Select a product</span>
            <span v-else-if="title_validation === 1">Move Urls to This product</span>
            <span v-else-if="title_validation === 2">Move Urls To a New Product</span>
            <!-- Use <span :class="(title_validation)?'success--text':'warning--text'">NEW</span> name or
            existed name with <span :class="(title_validation)?'success--text':'warning--text'">DIFFERENT</span> product type. -->
          </li>
          <li v-if="title_validation === 2">
            <v-icon v-if="manufacturer_validation" color="success">verified</v-icon>
            <v-icon v-else color="warning">warning</v-icon>
            Use
            <span :class="(manufacturer_validation)?'success--text':'warning--text'">VALID</span> manufacturer.
          </li>
          <!-- <li>
            <v-icon v-if="link_validation" color="success">verified</v-icon>
            <v-icon v-else color="warning">warning</v-icon>
            At least<span :class="(link_validation)?'success--text':'warning--text'"> ONE</span> client.
          </li> -->
        </ol>
      </v-card-subtitle>
      <v-card-text>
        <v-row>
          <v-col
            sm="12"
            :md="
              !new_product.title || new_product.title.length < 19 ? '3' : '4'
            "
          >
            <v-combobox
              :items="products"
              :search-input.sync="new_product.title"
              noFilter
              :ripple="false"
              clearable
              outlined
              hide-details
              clear-icon
              append-icon="expand_more"
              item-text="product_name"
              item-value="product_name"
              item-color="warning"
              label="Title"
              text
            ></v-combobox>
          </v-col>
          <v-col sm="12" md="2">
            <v-autocomplete
              :items="manufacturers"
              v-model="selected_manufacturer"
              :search-input.sync="new_product.manufacturer"
              noFilter
              :ripple="false"
              clearable
              outlined
              hide-details
              clear-icon
              append-icon="expand_more"
              item-text="manufacturer_name"
              item-value="manufacturer_name"
              item-color="success"
              label="Manufacturer"
              text
            >
            </v-autocomplete>
          </v-col>
          <v-col
            sm="12"
            :md="!selected_clients || selected_clients.length >= 4 ? '5' : '3'"
          >
            <v-select
              v-model="selected_clients"
              small-chips
              clearable
              multiple
              outlined
              hide-details
              :items="clients"
              label="Clients"
              id="clients"
            />
            <!-- :item-value="item"
              item-text="text" -->
          </v-col>
          <v-col
            sm="12"
            md="2"
          >
            <v-select
              v-model="selected_type"
              mandatory
              outlined
              hide-details
              :items="[{text: 'Exact',value: 'exact'}, {text: 'Similar',value: 'similar'}]"
              label="Type"
              id="type"
            />
          </v-col>
        </v-row>
        <div v-for="(url, index) in urls" :key="index" class="my-1">
          {{ url.domain_name }}: {{ url.url }}
        </div>
      </v-card-text>
      <v-card-actions>
        <!-- <v-btn @click="help"> ADD NAME </v-btn> -->
        <v-text-field
          label="New Brand Name"
          v-model="new_brand"
          class="wid300"
        ></v-text-field>
          <!-- style="width: 300px" -->
        <v-btn @click="add_brand"> ADD BRAND </v-btn>
        <v-spacer></v-spacer>
        <v-btn
          @click="submitNewProduct"
          x-large
          color="red darken-4"
          class="me-15 px-5"
          :disabled="!(title_validation && link_validation)"
          :loading="create_btn_loader"
        >
            <!-- && manufacturer_validation -->
            <!-- [...new_product.manufacturer].length >= 2 ||
            !manufacturers.find(
              (m) => m.manufacturer_name == new_product.manufacturer
            ) ||
            !!products.find((p) => p.product_name === new_product.title) ||
            [...new_product.title].length > 2 || -->
          Move To New PRODUCT
        </v-btn>
      </v-card-actions>
    </v-card>
    <v-snackbar
      v-model="snackbar.show"
      :timeout="snackbar.timeout"
      :color="snackbar.color"
    >
      {{ snackbar.text }}

      <template v-slot:action="{ attrs }">
        <v-btn
          color="primary"
          text
          v-bind="attrs"
          @click="snackbar.show = false"
        >
          Close
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
/* eslint-disable */
import { eliminate_negative_ids, myCapitallize } from "@/helpers/functions";
// import { productionBus } from "@/helpers/buses";

export default {
  name: "n-move-urls-new-product",
  props: {
    urls: Array,
  },
  data() {
    return {
      new_product: {
        manufacturer: "",
        title: "",
        // type: 'exact',
      },
      selected_manufacturer: "",
      manufacturers: [],
      products: [],
      selected_clients: [],
      snackbar: {
        show: false,
        text: "My timeout is set to 3000.",
        timeout: 3000,
        color: "red darken-2",
      },
      selected_type: 'exact',
      create_btn_loader: false,
      new_brand: '',
    };
  },
  methods: {
    help() {
      console.log('help');
      console.log(this.manufacturer_validation)
      console.log(this.title_validation)
      console.log(this.link_validation)
      },
    check_written_field(type, value) {
      const data = {
        task: `searching${myCapitallize(JSON.parse(JSON.stringify(type)))}`,
        payload: { value },
      };
      console.log("test data ", data);
      this.$store.dispatch("productionModule/general_api", data).then((res) => {
        const results = res.data.payload;
        console.log("rtesults", results);
        // this[`products`] = (results.status == 'success') ? results['products'] : [];
        this[`${type}s`] =
          results.status == "success" ? results[`${type}s`] : [];
      });
    },
    submitNewProduct() {
      this.create_btn_loader = true;
      const respond_data = {
        task: "moveToNewProduct",
        payload: {
          manufacturer_id: this.manufacturers.find(
            (m) => m.manufacturer_name === this.new_product.manufacturer
          ).manufacturer_id,
          product_name: this.new_product.title,
          clients: this.clients.filter((client) =>
            this.selected_clients.includes(client.value)
          ),
          urls: this.urls ,
          product_info: this.create_new_product_info(),
          product_from: this.$store.state.productionModule.selected_product.id
        },
      };
      console.log("respond_data", respond_data);
      this.$store
        .dispatch("productionModule/general_api", respond_data)
        .then((res) => {
          if (!res.data.payload) {
            this.snackbar.color = "red darken-2";
            this.snackbar.text = "Error: The product does not created.";
            this.snackbar.show = true;
          } else {
            this.snackbar.color = "blue-grey";
            this.snackbar.text = `Urls Moved to ${this.new_product.title}`;
            this.snackbar.show = true;
            const results = res.data.payload;
            this.$emit('close_dialog')
            this.$emit('reload_product')
            // if i want to go to new product
            // this.$emit('load_product', results.product_id)
          }
        }).catch(err => {
          console.log('ftiakse to error', err)
          this.snackbar.color = "red darken-2";
          this.snackbar.text = "Error: The product does not created.";
          this.snackbar.show = true;
        }).finally(() => this.create_btn_loader = false );
    },
    create_new_product_info() {
      const found_product = this.products.find(
        (p) => this.new_product.title === p.product_name
      );
      return {
        created_at: { date: "", time: "" },
        product_brand: {
          id: this.manufacturers.find(
            (m) => m.manufacturer_name === this.selected_manufacturer
          ).manufacturer_id,
          name: this.selected_manufacturer,
        },
        product_id: found_product === undefined ? 0 : found_product.product_id,
        product_name: this.new_product.title,
        product_source: "",
        product_type: this.selected_type,
      };
    },
    add_brand() {
      console.log('not working')
    },
  },
  watch: {
    "new_product.manufacturer"(newValue) {
      if (newValue && newValue.length >= 2) {
        this.check_written_field("manufacturer", newValue);
      }
    },
    "new_product.title"(newValue) {
      if (newValue && newValue.length >= 2) {
        this.check_written_field("product", newValue);
      }
    },
  },
  computed: {
    clients() {
      return this.$store.state.productionModule.clients_list;
    },
    manufacturer_validation() {
      return this.manufacturers.map(m => m.manufacturer_name).includes(this.new_product.manufacturer)
              && this.selected_manufacturer === this.new_product.manufacturer;
    },
    title_validation() {
      const first_validation = !this.new_product.title || this.new_product.title.length < 3;
      const names_of_products = this.products.map(p => p.product_name);
      if(first_validation){
        return false
      } else if (names_of_products.includes(this.new_product.title)) {
        return 1 // existing product
      }
      return 2; // create new product
    },
    link_validation() {
      return true;
      // return !!this.selected_clients.length;
    },
  },
};
</script>

<style scoped>
  .wid300 {
    flex: none !important ;
    width: 300px;
  }
</style>


// WEBPACK FOOTER //
// src/components/production/N_MoveUrlsToNew.vue